import { render, staticRenderFns } from "./SithMesStoolTransferTicketGenerationRecordList.vue?vue&type=template&id=33211aa7&"
import script from "./SithMesStoolTransferTicketGenerationRecordList.vue?vue&type=script&lang=js&"
export * from "./SithMesStoolTransferTicketGenerationRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports